var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLandingPageFile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 53,
    viewBox: "0 0 52 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 52,
    height: 52,
    rx: 26,
    fill: "#EFF6FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 14.3369V19.5001C28.5 20.2002 28.5 20.5502 28.6362 20.8176C28.7561 21.0528 28.9473 21.244 29.1825 21.3638C29.4499 21.5001 29.7999 21.5001 30.5 21.5001H35.6632M28.5 32.75H21M31 27.75H21M36 23.9853V33C36 35.1002 36 36.1503 35.5913 36.9525C35.2317 37.6581 34.6581 38.2317 33.9525 38.5913C33.1503 39 32.1002 39 30 39H22C19.8998 39 18.8497 39 18.0475 38.5913C17.3419 38.2317 16.7683 37.6581 16.4087 36.9525C16 36.1503 16 35.1002 16 33V20C16 17.8998 16 16.8497 16.4087 16.0475C16.7683 15.3419 17.3419 14.7683 18.0475 14.4087C18.8497 14 19.8998 14 22 14H26.0147C26.9319 14 27.3905 14 27.8221 14.1036C28.2048 14.1955 28.5705 14.347 28.9061 14.5526C29.2845 14.7845 29.6088 15.1088 30.2574 15.7574L34.2426 19.7426C34.8912 20.3912 35.2155 20.7155 35.4474 21.0939C35.653 21.4295 35.8045 21.7952 35.8964 22.1779C36 22.6095 36 23.0681 36 23.9853Z",
    stroke: "#0857C3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandingPageFile);
export default __webpack_public_path__ + "static/media/LandingPageFile.091d76ecac151147c00360929b3d87fd.svg";
export { ForwardRef as ReactComponent };